import { path, pipe } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const getActiveMessage = path(['listeningMode', 'messages', 'activeMessage']);
export const hasActiveMessage = pipe(getActiveMessage, Boolean);
